import Enum from "@rover/shared/js/types/Enum";
export default class NavBarTheme extends Enum<string> {
  static OPAQUE = new NavBarTheme('opaque');
  static isLocked = true;
}


// WEBPACK FOOTER //
// ../kibble/styles/NavBarTheme.ts